module.exports = __webpack_public_path__ + "static/img/client3.4560ee16.jpeg";